export default __webpack_public_path__ + "static/media/tropicanapic2.0d392b28.jpg";